import { useDispatch, useSelector } from 'react-redux';
import { BaseChipsGroup, BaseImageUpload, BaseTextarea, DurationInput, BaseInput, BaseDeleteButton, BaseAddNewButton } from './';
import {
  HANDLE_DURATION,
  SET_COLLECTION_PROP,
  HANDLE_CHIP_SELECTION,
  HANDLE_OUTLINE,
  HANDLE_ADD_DELETE_OUTLINE
} from '../store/modules/collection';
import './css/collection-information.scss';
import {
  PARTNER_COLLECTION,
  HOSTED,
  EDITORIAL,
  CUSTOM
} from '../utils/Constants';
import { updateCollectionImg } from '../store/api';
import { audience, specialties as specialtiesList } from '../store/modules/collection';
import './css/course-authors.scss';

export const CollectionInformation = function () {
  const { duration, description, homepageImage, targetAudiences, category, collectionHeadline, howWeWorkWith, collectionOutlines, type, partnershipType, videoId } =
    useSelector((state) => state.collection.data);
  const isPartnerCollectionWithVideo = type === PARTNER_COLLECTION && [HOSTED, EDITORIAL, CUSTOM].includes(partnershipType);
  const dispatch = useDispatch();
  const CHAR_LIMIT_DESC = (type === PARTNER_COLLECTION) ? 'Max limit is 279 characters': '';
  function handleInput(obj) {
    dispatch(SET_COLLECTION_PROP(obj));
  }

  function handleAddDeleteOutlines(action) {
    dispatch(HANDLE_ADD_DELETE_OUTLINE(action));
  }

  function handleOutlineInput(obj) {
    dispatch(HANDLE_OUTLINE(obj));
  }

  function handleDuration(obj) {
    dispatch(HANDLE_DURATION(obj));
  }

  async function handleImage({ key, action, imageName, formData }) {
    switch (action) {
      case 'upload':
        dispatch(
          SET_COLLECTION_PROP({
            key,
            value: key === 'partnersLogo' ? [imageName] : imageName
          })
        );
        await updateCollectionImg(formData);
        break;
      case 'delete':
        dispatch(
          SET_COLLECTION_PROP({
            key,
            value: key === 'partnersLogo' ? null : ''
          })
        );
        break;
    }
  }

  function handleChipSelection(obj) {
    dispatch(HANDLE_CHIP_SELECTION(obj));
  }

  return (
    <section className="collection-information" id="collection-information">
      <h2>Collection information</h2>

      <div className="duration-options">
        <b>Duration</b>
        <DurationInput name="hours" value={duration?.hours} onChange={handleDuration} />
        <DurationInput name="minutes" value={duration?.minutes} onChange={handleDuration} />
      </div>

      <BaseTextarea
        name="description"
        label="Description"
        sublabel={CHAR_LIMIT_DESC}
        value={description}
        onInput={handleInput}
      />

      <BaseImageUpload
        name="homepageImage"
        label="Homepage image"
        imageName={homepageImage}
        handleImage={handleImage}
      />

      {isPartnerCollectionWithVideo && (
        <BaseInput
          classes="video-id"
          name="videoId"
          label="Brightcove ID"
          type="text"
          value={videoId}
          onInput={handleInput}
        />
      )}

      {type === PARTNER_COLLECTION && <>
        <BaseTextarea
          name="collectionHeadline"
          label="Collection headline"
          value={collectionHeadline}
          onInput={handleInput}
          sublabel="This is the pull quote at the top of the page"
        />

        <BaseTextarea
          name="howWeWorkWith"
          label="How we work with"
          value={howWeWorkWith}
          sublabel="Describe how BMJ Learning has worked with this partner "
          onInput={handleInput}
        />

        <div className="course-authors m-b-24">
          <h2 className='outline-heading'>Collection outline</h2>
          {collectionOutlines && collectionOutlines.map(({ outlineTitle, outlineCopy }, index) => (
            <div className="author-group" key={index}>
              <h3>{`Outline ${index + 1}`}</h3>
              <BaseInput
                name={`outlineTitle${index + 1}`}
                label="Outline title"
                value={outlineTitle}
                width="w100"
                onInput={({ value }) => handleOutlineInput({ key: 'outlineTitle', value, index })}
              />
              <BaseTextarea
                name={`outlineCopy${index + 1}`}
                label="Outline copy"
                width="w100"
                value={outlineCopy}
                onInput={({ value }) => handleOutlineInput({ key: 'outlineCopy', value, index })}
              />
            </div>
          ))}
          <div className="flex flex-between">
            <BaseAddNewButton
              text="Add outline"
              onClick={() => handleAddDeleteOutlines('add')}
            />
            <BaseDeleteButton
              text="Delete last outline"
              onClick={() => handleAddDeleteOutlines('delete')}
            />
          </div>
        </div>
      </>}

      <BaseChipsGroup
        name="targetAudiences"
        label="Target audiences"
        options={audience}
        selected={targetAudiences}
        onSelect={handleChipSelection}
      />

      <BaseChipsGroup
        name="category"
        label="Specialties"
        options={specialtiesList}
        selected={category}
        onSelect={handleChipSelection}
      />
    </section>
  );
};
